import { ReactElement, useEffect, useState } from 'react';
import styled from 'styled-components';
import MaterialIcon from './icon/MaterialIcon';
import theme from '@/styles/theme';

interface Props {
  title: string;
  content: ReactElement | string;
  disabled?: boolean;
  isOpen?: boolean;
}
const Accordion = ({ title, content, disabled, isOpen = false }: Props) => {
  const [_isOpen, _setIsOpen] = useState(isOpen);
  const onChangeOpen = () => {
    if (disabled) return;
    _setIsOpen(!_isOpen);
  };

  useEffect(() => {
    _setIsOpen(isOpen);
  }, [isOpen]);
  return (
    <div>
      <Content onClick={onChangeOpen} isDisabled={disabled}>
        {title}
        {_isOpen ? (
          <MaterialIcon name={'expand_less'} color={theme.DF_COLOR.GRAY300} />
        ) : (
          <MaterialIcon name={'expand_more'} color={theme.DF_COLOR.GRAY300} />
        )}
      </Content>
      {_isOpen && content}
    </div>
  );
};

export default Accordion;

const Content = styled.div<{ isDisabled?: boolean }>`
  display: flex;
  justify-content: space-between;
  padding: 20px 0;
  cursor: pointer;

  ${({ theme, isDisabled }) => `
    ${theme.DF_TYPOGRAPHY.UI18SB};
    color: ${!isDisabled ? theme.DF_COLOR.GRAY900 : theme.DF_COLOR.GRAY200};
  `};
`;
